import { render } from "./RoutedChat.vue?vue&type=template&id=7de24d94&ts=true"
import script from "./RoutedChat.vue?vue&type=script&lang=ts"
export * from "./RoutedChat.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/RoutedChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7de24d94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7de24d94', __exports__)) {
    api.reload('7de24d94', __exports__)
  }
  
  module.hot.accept("./RoutedChat.vue?vue&type=template&id=7de24d94&ts=true", () => {
    api.rerender('7de24d94', render)
  })

}


export default __exports__